import { useTreeItem2 as useTreeItem2Export } from "./useTreeItem2.js";
export const useTreeItem2 = useTreeItem2Export;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const unstable_useTreeItem2 = useTreeItem2Export;